/* Generate a data-auto attribute for automation */
export const generateDataAuto = (key = '', name = '') => {
  return name ? `${key}_${name.toLowerCase().replace(/ /g, '_')}` : '';
};
